import { showToast } from "../components/ToastMessage/showToast";

type HandleApiResponseArgs = {
  response?: any;
  type: "success" | "error";
  toastId?: string;
  message?: string;
  setFieldError?: (field: string, message: string) => void;
};

export const handleApiResponse = (args: HandleApiResponseArgs): void => {
  const { response, type, message, toastId, setFieldError } = args;
  let toastMessage = message ?? "";

  if (type === "error") {
    const error = response;
    if (error?.data?.message) {
      toastMessage = error.data.message;
    } else if (typeof error?.error === "string") {
      toastMessage = error.error;
    } else {
      toastMessage = "An unknown error occurred";
    }

    // setfield error
    if (error?.data?.errors && Array.isArray(error?.data?.errors)) {
      error?.data?.errors?.forEach((eachError: any) => {
        switch (eachError?.field) {
          // brand provisioning
          case "BrandName":
            setFieldError && setFieldError("brand_name", eachError?.rule);
            break;

          // family provisioning
          case "FamilyName":
            setFieldError && setFieldError("family_name", eachError?.rule);
            break;
          case "TimezoneFormatID":
            setFieldError &&
              setFieldError("timezone_format_id", eachError?.rule);
            break;

          //model provisioning
          case "ModelName":
            setFieldError && setFieldError("model_name", eachError?.rule);
            break;

          // firmware provisioning
          case "FirmwareVersion":
            setFieldError && setFieldError("firmware_version", eachError?.rule);
            break;
          case "ProvisioningUrl":
            setFieldError && setFieldError("provisioning_url", eachError?.rule);
            break;

          // template provisioning
          case "TemplateName":
            setFieldError && setFieldError("template_name", eachError?.rule);
            break;
          case "FirmwareID":
            setFieldError && setFieldError("firmware_id", eachError?.rule);
            break;

          // file provisioning
          case "FileName":
            setFieldError && setFieldError("file_name", eachError?.rule);
            break;
          case "FileNameTemplate":
            setFieldError &&
              setFieldError("file_name_template", eachError?.rule);
            break;
          case "ConfigTemplate":
            setFieldError && setFieldError("config_template", eachError?.rule);
            break;

          // common fields
          case "IsActive":
            setFieldError && setFieldError("is_active", eachError?.rule);
            break;
        }
      });
    }
  }

  showToast(
    type,
    { message: toastMessage },
    { toastId: toastId || "default-error-toast" }
  );
};
